import React from "react";
import ReactDOM from "react-dom";
import { observer } from "mobx-react-lite";
import { DOMInjector } from "./DOMInjector";

export const DOMInjectorProvider: React.FC = observer(() => {
  return (
    <React.Fragment>
      {DOMInjector.injectedElements.map(({ Component, host, props }) => ReactDOM.createPortal(<Component {...props} />, host))}
    </React.Fragment>
  );
});
